export default __webpack_public_path__ + "static/media/arrowRightWhite.0a2dfd27.svg";